export function touchPairDistance(
  a: { clientX: number; clientY: number },
  b: { clientX: number; clientY: number }
): number {
  return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY)
}

export function resolvePinchZoom(args: {
  startZoom: number
  startDistance: number
  currentDistance: number
  minZoom: number
  maxZoom: number
}): number {
  const { startZoom, minZoom, maxZoom } = args
  if (args.startDistance <= 0 || args.currentDistance <= 0) {
    return Math.min(maxZoom, Math.max(minZoom, startZoom))
  }
  return Math.min(
    maxZoom,
    Math.max(minZoom, startZoom * (args.currentDistance / args.startDistance))
  )
}
